export default "__VITE_ASSET__Cr$Rllnk__"